<app-touareg-control-state-layout
  [waiting]="true"
></app-touareg-control-state-layout>
